import { render, staticRenderFns } from "./MonitorTable.vue?vue&type=template&id=0b375424&"
import script from "./MonitorTable.vue?vue&type=script&lang=js&"
export * from "./MonitorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports